<template>
  <Header_en/>
  <Enterprise_index_en></Enterprise_index_en>
  <Enterprise_page_en></Enterprise_page_en>
  <Footer_en></Footer_en>
</template>

<script>
import Header_en from "@/components/EN/Header_en";
import Enterprise_index_en from "@/components/EN/enterprise/Enterprise_index_en";
import Enterprise_page_en from "@/components/EN/enterprise/Enterprise_page_en";
import Footer_en from "@/components/EN/Footer_en";
export default {
  name: 'Enterprise_en',
  components: {Enterprise_page_en, Enterprise_index_en,Footer_en, Header_en},
}

</script>